var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.995 15.5133C38.865 15.4917 38.7133 15.4917 38.5833 15.5133C35.5933 15.405 33.21 12.9567 33.21 9.92332C33.21 6.82498 35.7016 4.33331 38.8 4.33331C41.8983 4.33331 44.39 6.84665 44.39 9.92332C44.3683 12.9567 41.985 15.405 38.995 15.5133Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.7632 31.2867C39.7316 31.785 43.0033 31.265 45.2999 29.7267C48.3549 27.69 48.3549 24.3534 45.2999 22.3167C42.9816 20.7784 39.6666 20.2583 36.6982 20.7783",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.9292 15.5133C13.0592 15.4917 13.2108 15.4917 13.3408 15.5133C16.3308 15.405 18.7142 12.9567 18.7142 9.92332C18.7142 6.82498 16.2225 4.33331 13.1242 4.33331C10.0259 4.33331 7.53418 6.84665 7.53418 9.92332C7.55585 12.9567 9.93918 15.405 12.9292 15.5133Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.1609 31.2867C12.1926 31.785 8.92093 31.265 6.62426 29.7267C3.56926 27.69 3.56926 24.3534 6.62426 22.3167C8.94259 20.7784 12.2576 20.2583 15.2259 20.7783",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 31.6983C25.8698 31.6767 25.7182 31.6767 25.5882 31.6983C22.5982 31.59 20.2148 29.1416 20.2148 26.1083C20.2148 23.01 22.7065 20.5183 25.8048 20.5183C28.9032 20.5183 31.3948 23.0316 31.3948 26.1083C31.3732 29.1416 28.9898 31.6117 25.9998 31.6983Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6946 38.5233C16.6396 40.5599 16.6396 43.8966 19.6946 45.9333C23.1612 48.2516 28.8379 48.2516 32.3046 45.9333C35.3596 43.8966 35.3596 40.5599 32.3046 38.5233C28.8596 36.2266 23.1612 36.2266 19.6946 38.5233Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.12a00d8f06d0ab5d3bbc7c3d924702f1.svg";
export { ForwardRef as ReactComponent };